export const downloadFile = async (
  fileUrl: string | undefined,
  fileName: string = 'file.png'
): Promise<boolean> => {
  try {
    if (!fileUrl) return false;

    const response = await fetch(fileUrl);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    if (link.parentNode) {
      link.parentNode.removeChild(link);
    }
    window.URL.revokeObjectURL(url);
    return true;
  } catch (error) {
    console.error('Failed to download file:', error);
    return false;
  }
};

export const getPublisherIdFromPath = (pathname: string): string | undefined =>
  pathname.match(/\/publisher\/([^/]+)/)?.[1];

export const replacePublisherIdInPath = (
  currentPath: string,
  newPublisherId: string
) => {
  const regex = /(\/publisher\/)([a-fA-F0-9-]+)(\/.*|$)/;

  if (regex.test(currentPath)) {
    return currentPath.replace(regex, `$1${newPublisherId}$3`);
  }

  return `/publisher/${newPublisherId}/offers`;
};
